import { type Player } from '@common/clients/api';

/** Generate an array of 11 placeholders */
export const allPlaceHolderPlayers: Player[] = Array.from({ length: 11 }, (_, index) => ({
    id: (index + 1).toString().padStart(2, '0'),
    name: '',
    shirtNumber: 0,
}));

/* The auto generated placeholders have ids from 01 to 12 */
export const isPlaceholderPlayer = (playerID: string) => playerID.length < 3;

export const normalizeFormation = (formation: string) => formation.replaceAll('-', '');

export const FORMATIONS: string[] = [
    '4-3-3',
    '4-3-1-2',
    '4-3-2-1',
    '4-4-2',
    '4-4-1-1',
    '4-2-3-1',
    '4-2-1-3',
    '4-2-4',
    '4-2-2-2',
    '4-1-3-2',
    '4-1-2-1-2',
    '4-1-4-1',
    '4-5-1',
    '5-3-2',
    '5-2-3',
    '5-2-1-2',
    '5-4-1',
    '3-4-3',
    '3-5-2',
    '3-4-2-1',
    '3-4-1-2',
];

export const findFormation = (normalized: string) =>
    FORMATIONS.find((f) => normalizeFormation(f) === normalized) ?? null;
